export default "query publicationTargets{\n    publicationTargets\n}";